<template>
  <div class="container has-text-centered">
      <h3 class="title has-text-grey">Formulario de Inscripción</h3>
    <formulario-inscripcion/>
  </div>
  
</template>

<script>
import FormularioInscripcion from "@/components/FormularioInscripcion.vue";



export default {
  name: "inscripcionView",
  components: {
    FormularioInscripcion,
  },
  data: function () {
    return {};
  },
  computed: {
  },
  methods: {     
  },
  mounted(
  ) {}
};
</script>

<style>
</style>